import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import ErrorBoundary from "@/components/ErrorBoundary";
import { AuthProvider } from "@/context/AuthContext";
import { SiteConfigProvider } from "@/context/SiteConfigContext";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Services from "@/components/Services";
import PackageQuiz from "@/components/PackageQuiz";
import Gallery from "@/components/Gallery";
import Reviews from "@/components/Reviews";
import BookNow from "@/components/BookNow";
import Contact from "@/components/Contact";
import Login from "@/pages/Login";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";

const Landing = () => (
  <>
    <div className="noise-overlay" aria-hidden="true" />
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <About />
      <Services />
      <PackageQuiz />
      <Gallery />
      <Reviews />
      <BookNow />
    </main>
    <Contact />
  </>
);

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ErrorBoundary>
      <AuthProvider>
        <SiteConfigProvider>
          <BrowserRouter>
            <div className="min-h-screen bg-[#050505] text-white">
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/login" element={<Login />} />
                <Route path="/account" element={<Account />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
            </div>
          </BrowserRouter>
        </SiteConfigProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
